const FAQ_TYPES = {
  HOST: "Host",
  GENERAL: "Guest",
};

const FAQS = ["HOST", "GUEST"];

const SORT_BY = {
  PRICE_HIGH_TO_LOW: "Price high to low",
  PRICE_LOW_TO_HIGH: "Price low to high",
  NEWEST_DATE_FIRST: "Newest date first",
  OLDEST_DATE_FIRST: "Oldest date first",
};

const REPORT_TYPES = [
  {
    value: "Inappropriate Image",
    label: "Inappropriate Image",
  },
  {
    value: "Derogatory language",
    label: "Derogatory language",
  },
  {
    value: "General Incompatibility",
    label: "General Incompatibility",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const GENDER = {
  MEN: "Man",
  WOMEN: "Woman",
  NON_BINARY: "Non-Binary",
};

const GENDERDECODE: Record<string, string> = {
  Men: "Man",
  Women: "Woman",
};

const GENDERDECODELOOKING: Record<string, string> = {
  Men: "Men",
  Women: "Women",
};

const CONNECTION_PREFERENCE = {
  OPEN_TO_ANYTHING: "Open to anything",
  FRIENDSHIP: "Friendship",
  DATING: "Dating",
};

const CONNECTION_PREFERENCE_LABELS = {
  OPEN_TO_BOTH: "Open to both",
  FRIENDSHIP: "Friendship",
  DATING: "Dating",
};

const DATE_FILTER = {
  TODAY: "Today",
  TOMORROW: "Tomorrow",
  THIS_WEEKEND: "This Weekend",
};

const REVENUE_DATE_FILTER = {
  TODAY: "Today",
  THIS_WEEK: "This Week",
  THIS_MONTH: "This Month",
  ALL: "All",
};

const REVENUE_DATE_FILTER_OPTIONS = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Last 7 Days",
    value: "last_seven_days",
  },
  {
    label: "Last 30 Days",
    value: "last_thirty_days",
  },
];

const CONNECTION_STATUS = {
  DATING: "Heart",
  OPEN_TO_ANYTHING: "Open",
  FRIENDSHIP: "Handshake",
  UNMATCH: " ",
};

const MY_EVENTS_TYPES = {
  UPCOMING: "Upcoming",
  INVITED: "Invited",
  ATTENDED: "Attended",
  // ALL_PAST: 'All Past'
};

const HOST_CENTER_TYPES = {
  UPCOMING: "Upcoming",
  PAST: "Past",
  DRAFT: "Drafts",
};

const EVENT_ATTENDING_ANSWER = {
  YES: "Yes",
  MAYBE: "Maybe",
  NO: "No",
};
const EVENT_ATTENDING_STATUS = {
  GOING: "Going",
  MAYBE: "Maybe",
  NOT_GOING: "Not Going",
};

const DRAWERS = {
  GUEST_LIST: "Guest List",
  GROUP_CHAT: "Event Chat",
  BUY_TICKETS: "Buy Tickets",
  PAYMENT: "Payment",
  TICKET: "Ticket",
  USER_TICKETS: "Tickets",
  CONNECTION: "Profile",
  TICKETS: "Tickets",
  PAYOUT_REQUEST: "Payout Request",
  PAYOUT_SUMMARY: "Payouts",
  GUEST_ATTENDANCE_LIST: "Guest Attendance",
  CONTACT_HOST: "Contact Host",
  SUBSCRIBED_LIST: "Host Subscriptions",
  GUEST_APPROVE: "Guest Approval",
  RSVP_PENDING_WITHDRAW: "Withdraw RSVP Request",
};

const GUEST_LIST_TABS = {
  // INVITED: "Invited",
  GOING: "Going",
  MAYBE: "Maybe",
};

const LOCAL_STORAGE = {
  USER_TOKEN: "user_token",
  USER_MOBILE_NUMBER: "userMobileNumber",
  USER_ID: "userID",
  SHOW_DETAIL_PAGE: "showDetailPage",
  CONTACT_LIST: "contactList",
  USER_EMAIL: "userEmail",
  REMEMBER_PREFERENCE: "rememberPreference",
  REQUEST_TYPE: "requestType",
  PROFILE_STATUS: "profileStatus",
};

const EVENT_SHARE_TYPE = {
  SHARE: "Share",
  REDEEM: "Redeem",
};

const API_VERSION = {
  V1: "v1",
  V2: "v2",
};

enum ButtonVisibility {
  Hidden = "hidden",
  Visible = "visible",
}
const NOTIFICATION_REDIR_LIST = ["event", "like", "matched"];
const WEB_URL: any = process.env.REACT_APP_WEB_URL;
const WEB_SUPPORT_EMAIL: any = process.env.REACT_APP_WEB_SUPPORT_EMAIL;

const AUTH_NAVIGATE_OPTIONS = {
  KYC: "KYC",
  PROMPTS: "Prompts",
  NEW_USER: "NewUser",
  NEW_WEB_USER: "newWebUser",
  COMPLETED: "Completed",
  ONBOARDING: "Onboarding",
  KYC_REQUESTED: "KYC Requested",
};

const CONNECTION_REQUEST_STATUS = {
  REQUEST_SENT: "Connection Request Sent",
  REQUEST_MATCHED: "Matched",
};

const EVENT_LIST_LIMIT_PER_SCREEN = {
  DISCOVER: 20,
  EVENTS: 20,
  HOST_CENTER: 20,
  TEXT_BLAST_HOST_EVENT: 20,
  PAYOUT_PAGE_LIMIT: 20,
};

const MEETING_PURPOSE_ORDER = ["friendship", "dating", "open to anything"];

const STATUS_CODE_MAP:any = {
  Open: "Open to Both",
  Handshake: "Friendship / Professional",
  Heart: "Dating",
};

export {
  FAQ_TYPES,
  SORT_BY,
  DATE_FILTER,
  MY_EVENTS_TYPES,
  HOST_CENTER_TYPES,
  EVENT_ATTENDING_ANSWER,
  GUEST_LIST_TABS,
  LOCAL_STORAGE,
  EVENT_SHARE_TYPE,
  EVENT_ATTENDING_STATUS,
  API_VERSION,
  DRAWERS,
  GENDER,
  CONNECTION_PREFERENCE,
  CONNECTION_STATUS,
  REVENUE_DATE_FILTER,
  REPORT_TYPES,
  ButtonVisibility,
  NOTIFICATION_REDIR_LIST,
  WEB_URL,
  WEB_SUPPORT_EMAIL,
  AUTH_NAVIGATE_OPTIONS,
  CONNECTION_REQUEST_STATUS,
  EVENT_LIST_LIMIT_PER_SCREEN,
  REVENUE_DATE_FILTER_OPTIONS,
  GENDERDECODE,
  FAQS,
  CONNECTION_PREFERENCE_LABELS,
  GENDERDECODELOOKING,
  MEETING_PURPOSE_ORDER,
  STATUS_CODE_MAP,
};
